<template>
  <div class="NewsList">
    <div class="pages-content">
      <div class="pages-about-gywm">
        <div class="pages-xwgg-text">
          <h1>
            {{ $t("NewsTitle") }}
          </h1>
          <div class="box">
            <ul class="pages-xwgg-ul-list msg-scroll">
              <li
                class="items g-db clearfix"
                v-for="(val, index) in NewsList"
                :key="index"
              >
                <em class="xwgg-xw-em">
                  {{ val.name }}
                </em>
                <div class="clearfix news_content">
                  <p>
                    <a
                      :href="val.URL"
                      :title="val.title"
                      target="_blank"
                    >
                      {{ val.title }}
                    </a>
                  </p>
                  <span>
                    {{ val.Date }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
  </div>
</template>

<script>
// import { cnNewsList, enNewsList } from './js/NewsList'
export default {
  name: 'NewsList',
  data() {
    return {
      NewsList: '',
    }
  },
  mounted() {
    // this.Historys.forEach((item, index, arr) => {
    //   if (item.Text.length == 1) {
    //     item.MarginTop = "30px";
    //   }
    // });
    // this.History.reverse();
    const script = document.createElement('script')
    script.src = `https://s2.sonkwostatic.cn/ceasia_hk/js/data/NewsList.js?v=${new Date().getTime()}`
    script.onload = () => {
      // eslint-disable-next-line no-undef
      this.NewsList = enNewsList
      // eslint-disable-next-line no-undef, no-sequences
      return enNewsList, cnNewsList
    }
    document.head.appendChild(script)
  },
  methods: {
    currentChange(e) {
      this.currentPage = e
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
  },
  created() {
    let language = this.$i18n.locale
    let enNewsList
    console.log(this.$i18n.locale, '....')
    // eslint-disable-next-line no-undef
    if (enNewsList !== '' || cnNewsList !== '') {
      if (language === 'en') {
        // eslint-disable-next-line no-undef, no-sequences
        this.NewsList = enNewsList
      } else {
        // eslint-disable-next-line no-undef, no-sequences
        this.NewsList = cnNewsList
      }
    }
  },
  beforeUpdate() {
    let language = this.$i18n.locale
    console.log(language)

    // eslint-disable-next-line no-undef
    if (enNewsList !== '' || cnNewsList !== '') {
      if (language === 'en') {
        // eslint-disable-next-line no-undef, no-sequences
        this.NewsList = enNewsList
      } else {
        // eslint-disable-next-line no-undef, no-sequences
        this.NewsList = cnNewsList
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import './style/NwesList.min.css';
</style>



// WEBPACK FOOTER //
// src/components/news/NewsList.vue